import React from 'react';
import { BdFlag } from '../brand/BdFlag';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  flag?: boolean;
  screen?: string;
}
export function PageHeader({
  title,
  subtitle,
  actions,
  flag,
  screen
}: PageHeaderProps) {
  return <div className="mb-6 flex flex-wrap items-end justify-between gap-4" data-id="element-151" data-mp="xkimiygof8kb">
      <div data-id="element-152" data-mp="xmbsscndnqrs">
        {screen && <div className="mb-1 text-xs font-medium uppercase tracking-wide text-[#1769AA]" data-id="element-153" data-mp="9uejotbbbcud">{screen}</div>}
        <h1 className="flex items-center gap-3 text-2xl font-bold text-[#003B71]" data-id="element-154" data-mp="4vtioro8kp4v">
          {flag && <BdFlag width={34} data-id="element-155" data-mp="jskk16hh0ax4" />}
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground" data-id="element-156" data-mp="jqrc7nv4fknj">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2" data-id="element-157" data-mp="evu4qldhpjcr">{actions}</div>}
    </div>;
}